import React from 'react';
import Lightbox from 'react-image-lightbox';

export default function LightBoxComponent({ photos, photoIndex, setPhotoIndex, isOpen, setIsOpen }) {
  return (
    isOpen && (
      <Lightbox
        mainSrc={photos[photoIndex]}
        nextSrc={photos[(photoIndex + 1) % photos.length]}
        prevSrc={photos[(photoIndex + photos.length - 1) % photos.length]}
        onCloseRequest={() => setIsOpen(false)}
        onMovePrevRequest={() => setPhotoIndex((photoIndex + photos.length - 1) % photos.length)}
        onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % photos.length)}
      />
    )
  );
}
